import type { OverlayScrollbarsComponentRef } from 'overlayscrollbars-react';

export const getContainerElementFromOverlayScrollbarsRef = (ref: React.RefObject<OverlayScrollbarsComponentRef>) =>
  ref.current?.osInstance()?.elements().viewport || null;
